import React, { forwardRef, useEffect, useState } from "react";
import styles from "./AuditLogDetails.module.sass";
import {
    SovosBox,
    SovosCard,
    SovosCardHeader,
    SovosIcon,
    SovosMenuItem,
    SovosSelect,
    SovosTypography,
} from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import dateFormat from "dateformat";
import { List } from "mosaic-react-icons";
import { buildGenericDetailsComponent, renderRowJson } from "./componentUtils";

const AuditLogDetails = (props, ref) => {
    const { data, status } = props;
    const { i18n } = useGlobalValue();

    const { items = [] } = data || {};
    const [rawDataInfoArray, setRawDataInfoArrau] = useState([]);
    const [version, setVersion] = useState("");
    const filteredRawDataInfoArray = rawDataInfoArray.filter((elem) => elem.ID === version);

    useEffect(() => {
        if (items?.length) {
            setRawDataInfoArrau(items);
            setVersion(items[0].ID);
        }
    }, [items]);
    return status !== "loading" ? (
        <form className={styles["content"]}>
            <SovosBox>
                <SovosBox sx={{ padding: "0.5rem 0 2rem 0" }}>
                    <SovosSelect
                        onChange={(event) => {
                            setVersion(event.target.value);
                        }}
                        value={version}
                        label={i18n`version`}
                        variant={"standard"}
                    >
                        {(rawDataInfoArray || []).map((info, index) => (
                            <SovosMenuItem value={info.ID} key={info.ID}>
                                {index === 0
                                    ? i18n`Current Version`
                                    : `Version ${index + 1}: ${dateFormat(new Date(info.CreatedAt), "yyyy-mm-dd HH:mm:ss")}`}
                            </SovosMenuItem>
                        ))}
                    </SovosSelect>
                </SovosBox>
                <SovosBox>
                    {(filteredRawDataInfoArray || []).map((rawDataInfo, index) => (
                        <SovosBox key={index}>
                            <SovosCard
                                sx={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1,
                                    bgcolor: "white",
                                    flexDirection: "row",
                                    marginBottom: "4rem",
                                }}
                            >
                                <SovosBox sx={{ paddingBottom: "1rem" }}>
                                    <SovosCardHeader sx={{ paddingLeft: "0" }}>
                                        <SovosIcon
                                            sx={{ paddingRight: "2rem" }}
                                            children={<List fontSize="20" />}
                                        />
                                        <SovosTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            children={i18n`Details`}
                                        />
                                    </SovosCardHeader>
                                </SovosBox>
                                {buildGenericDetailsComponent(rawDataInfo, i18n)}
                            </SovosCard>
                            <SovosCard
                                sx={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1,
                                    bgcolor: "white",
                                    flexDirection: "row",
                                    marginBottom: "4rem",
                                    maxHeight: "45vh",
                                    overflowY: "auto",
                                }}
                            >
                                <SovosBox sx={{ paddingBottom: "1rem" }}>
                                    <SovosCardHeader sx={{ paddingLeft: "0" }}>
                                        <SovosIcon
                                            sx={{ paddingRight: "2rem" }}
                                            children={<List fontSize="20" />}
                                        />
                                        <SovosTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            children={i18n`New Row`}
                                        />
                                    </SovosCardHeader>
                                </SovosBox>
                                {renderRowJson(rawDataInfo.NewRow)}
                            </SovosCard>
                            <SovosCard
                                sx={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1,
                                    bgcolor: "white",
                                    flexDirection: "row",
                                    marginBottom: "4rem",
                                    maxHeight: "45vh",
                                    overflowY: "auto",
                                }}
                            >
                                <SovosBox sx={{ paddingBottom: "1rem" }}>
                                    <SovosCardHeader sx={{ paddingLeft: "0" }}>
                                        <SovosIcon
                                            sx={{ paddingRight: "2rem" }}
                                            children={<List fontSize="20" />}
                                        />
                                        <SovosTypography
                                            variant="h6"
                                            fontWeight="bold"
                                            children={i18n`Payload Details`}
                                        />
                                    </SovosCardHeader>
                                </SovosBox>
                                {renderRowJson(rawDataInfo.OldRow)}
                            </SovosCard>
                        </SovosBox>
                    ))}
                </SovosBox>
            </SovosBox>
        </form>
    ) : null;
};

const AuditLogDetailsRef = forwardRef(AuditLogDetails);

AuditLogDetailsRef.queries = (args) => {
    const { id, importId, fiscalYear, projectId, entity, modulePrefix } = args;
    return [
        {
            resource: `raw_data_by_id`,
            args: {
                id: `${id}`,
                entity,
                projectId,
                fiscalYear,
                modulePrefix,
                importId,
            },
            body: `items`,
        },
    ];
};

AuditLogDetailsRef.dataMapper = ["data"];

export default AuditLogDetailsRef;
